export default "/assets/images/app-update-img-03.a97cbe3e1dba0ebc.png";